import script from "./SogCardActionMoreButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SogCardActionMoreButton.vue?vue&type=script&setup=true&lang=ts"

import "./SogCardActionMoreButton.vue?vue&type=style&index=0&id=6e41d863&lang=css"

const __exports__ = script;

export default __exports__